/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { createAction } from ".";

export const CONTEXT_SET_ONLINE_ACTION = "context.setOnline";
export const CONTEXT_SET_LOADING_ACTION = "context.setLoading";

export const setOnline = createAction<boolean>(CONTEXT_SET_ONLINE_ACTION);
export const setLoading = createAction<boolean>(CONTEXT_SET_LOADING_ACTION);



// WEBPACK FOOTER //
// ./src/store/actions/context.actions.ts